const widgetConfig = {
    widgets: {
        metadata: {
            Table: {
                title: "dashboard.widgets.types.table",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: true,
            },
            Graph: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "2",
                id: "Graph",
                dashboard: true,
            },
            PieChart: {
                title: "dashboard.widgets.types.pie",
                order: "1",
                width: "2",
                id: "PieChart",
                dashboard: true,
            },
            BarChart: {
                title: "dashboard.widgets.types.bar",
                order: "5",
                width: "2",
                id: "BarChart",
                dashboard: true,
            },
            SingleMetric: {
                title: "dashboard.widgets.types.single",
                order: "4",
                width: "1",
                id: "SingleMetric",
                dashboard: true,
            },
            Custom: {
                title: "Custom",
                order: "6",
                width: "2",
                id: "Custom",
            },
            defaultType: {
                title: "Default",
                id: "Default",
                dashboard: false,
            },
            ComparedBar: {
                title: "ComparedBar",
                width: "2",
                dashboard: false,
            },
            ComparedLine: {
                title: "ComparedLine",
                width: "2",
                dashboard: false,
            },
            PeriodOverPeriodVisits: {
                title: "PeriodOverPeriodVisits",
                width: "2",
                dashboard: false,
            },
            SearchOverviewTotalVisits: {
                title: "SearchOverviewTotalVisits",
                width: "2",
                dashboard: false,
            },
            SearchOverviewTotalVisitsTable: {
                title: "SearchOverviewTotalVisitsTable",
                width: "2",
                dashboard: false,
            },
            SearchOrganicPaidOverviewPieChart: {
                title: "SearchOrganicPaidOverviewPieChart",
                width: "2",
                dashboard: false,
            },
            SearchOrganicPaidOverviewTable: {
                title: "SearchOrganicPaidOverviewTable",
                width: "2",
                dashboard: false,
            },
            WWOSocialBar: {
                title: "WWOSocialBar",
                width: "2",
                dashboard: false,
            },
            InstoreTrafficBar: {
                title: "InstoreTrafficBar",
                width: "2",
                dashboard: false,
            },
            KeywordsGraph: {
                title: "Graph",
                order: "2",
                width: "2",
                id: "Graph",
                dashboard: false,
            },
            KeywordsGraphDashboard: {
                title: "Graph",
                order: "2",
                width: "2",
                id: "Graph",
                dashboard: false,
            },
            KeywordOverviewStats: {
                title: "dashboard.widgets.types.single",
                order: "4",
                width: "1",
                id: "SingleMetric",
                dashboard: false,
            },
            LeaderBySourceTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            RelatedCategoriesTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            KeywordsDashboardTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            IndustryKeywordsDashboardTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            IndustryReferralsDashboardTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            TopReferralsDashboardTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            WebsiteKeywordsDashboardTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            DesktopVSMobile: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            CategoryShareGraphDashboard: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            BarChartMMXDashboard: {
                title: "List",
                order: "3",
                width: "2",
                id: "BarChart",
                dashboard: false,
            },
            PieChartMMXDashboard: {
                title: "List",
                order: "3",
                width: "2",
                id: "PieChart",
                dashboard: false,
            },
            TableDynamicColumnsLeader: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            MmxVisitDurationDashboard: {
                title: "Graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            MmxChannelsGraphDashboard: {
                title: "Graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            MmxPagesPerVisitDashboard: {
                title: "Graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            MmxBounceRateDashboard: {
                title: "Graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            MmxTrafficShareDashboard: {
                title: "Graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            ExternalTrafficTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            PopularPagesTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            TableSearchKeywordsDashboard: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            TableWebsiteKeywordsDashboard: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            TableLandingPageDashboard: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            TableKeywordAnalysisDashboard: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },

            AudienceInterestsTable: {
                title: "List",
                order: "3",
                width: "3",
                id: "Table",
                dashboard: false,
            },
            SearchCompetitorsPaid: {
                title: "List",
                order: "3",
                width: "3",
                id: "Table",
                dashboard: false,
            },
            SearchCompetitorsOrganic: {
                title: "List",
                order: "3",
                width: "3",
                id: "Table",
                dashboard: false,
            },
            OutgoingReferralsDashboardTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            LeadingFoldersTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            AppEngagementOverviewTable: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            SegmentsMonthlyVisitsGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsUniqueVisitorsGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsPageViewsGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsPagePerVisitGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsVisitDurationGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsBounceRateGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsGeography: {
                title: "Table",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            SegmentsTrafficShareGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsGroupMonthlyVisitsGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsGroupTrafficShareGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsPageViewsGroupGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsPagePerVisitGroupGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsVisitDurationGroupGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsBounceRateGroupGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsUniqueVisitorsGroupGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            SegmentsGeographyGroupWidget: {
                title: "Table",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            MarketShares: {
                title: "BarChart",
                order: "3",
                width: "4",
                id: "BarChart",
                dashboard: false,
            },
            MarketSharesGraph: {
                title: "Graph",
                order: "3",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            AppStoreInstallAndDownloadsOverviewTable: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            AppDemographicsGraph: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "2",
                id: "Graph",
                dashboard: false,
            },
            TopSitesTable: {
                title: "List",
                width: "3",
                order: "3",
                id: "Table",
                dashboard: false,
            },
            WWOTopRefCategories: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            WWOTopKeywordsTable: {
                title: "List",
                order: "3",
                width: "2",
                id: "Table",
                dashboard: false,
            },
            ExternalTrafficBarChart: {
                title: "ExternalTrafficBarChart",
                width: "2",
                dashboard: false,
            },
            RetentionTable: {
                title: "List",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            EngagementTableDashboard: {
                title: "List",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            RetentionGraph: {
                title: "Graph",
                width: "2",
                id: "Graph",
                dashboard: false,
            },
            AppEngagementMetricsDashboardGraph: {
                title: "Graph",
                width: "2",
                id: "Graph",
                dashboard: false,
            },
            AppDistributionTable: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            AppRetentionDashboardGraph: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            AppRetentionDashboardTable: {
                title: "List",
                order: "3",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            BarChartDemographics: {
                title: "BarChart",
                width: "2",
                dashboard: false,
            },
            BarChartDemographicsGender: {
                title: "BarChart",
                width: "2",
                dashboard: false,
            },
            PieChartGender: {
                title: "PieChart",
                width: "2",
                dashboard: false,
            },
            KeywordAnalysisTotalVisits: {
                title: "SingleMetric",
                id: "SingleMetric",
                width: "1",
                dashboard: false,
            },
            TrafficGrowthComparison: {
                title: "TrafficGrowthComparison",
                id: "SingleMetric",
                width: "4",
                dashboard: false,
            },
            AdSpendLineChart: {
                width: "4",
            },
            PaidSearchAdsTable: {
                width: "4",
            },
            SearchAdsTable: {
                width: "4",
            },
            EngagedVisitsSupportGraph: {
                width: "2",
            },

            IndustryEngagementVisitsGraph: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "2",
                id: "Graph",
                dashboard: false,
            },

            //Rank tracker widgets
            RankTrackerKeywordsReportTable: {
                title: "dashboard.widgets.types.table",
                order: "1",
                width: "4",
                id: "Table",
                dashboard: false,
            },
            RankTrackerOverviewPerformanceGraph: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            KeywordAnalysisGraphDashboard: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            KeywordAnalysisTrendOverTimeGraph: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
            AdIntelligencePerformanceOvertimeGraph: {
                title: "dashboard.widgets.types.graph",
                order: "2",
                width: "4",
                id: "Graph",
                dashboard: false,
            },
        },
        metrics: {
            /* auto-injected */
        },
        utilities: {
            "table-pager": {
                id: "table-pager",
                properties: {
                    param: "page",
                },
            },
            "table-search": {
                id: "table-search",
                properties: {
                    param: "filter",
                    column: "Domain",
                    operator: "contains",
                    type: "string",
                },
            },
            dropdown: {
                id: "dropdown",
                properties: {
                    param: "filter",
                    type: "string",
                    column: "category",
                    operator: "category",
                    placeholder: "All",
                },
            },
            "time-granularity": {
                id: "time-granularity",
                properties: {
                    Daily: "true",
                    Weekly: "true",
                    Monthly: "true",
                    toggleOptions: ["Daily", "Weekly", "Monthly"],
                    default: "Monthly",
                    param: "timeGranularity",
                },
            },
            "table-export": {
                id: "table-export",
                properties: {},
            },
            "chart-export": {
                id: "chart-export",
                properties: {},
            },
            "ga-verify": {
                id: "ga-verify",
                properties: {},
            },
            "title-dropdown": {
                id: "title-dropdown",
                properties: {},
            },
        },
        types: {
            table: {
                services: [],
            },
            pie: {
                services: [],
            },
            line: {
                services: [],
            },
            singleMetric: {
                services: [],
            },
        },
    },
};
export default widgetConfig;
